<template>
      <div class="filterRow d-flex   mb-2 p-3 bg-white mobile_side_dc">
        <div class="d-flex mr-3">
            <div class="f-col">
                <label class="mobile_lbl">From Date</label>
                <kendo-datepicker class="w-100 date_pik_mbl" v-model="FromTime" :name="'Date of start'" :format="'dd/MM/yyyy'"
                    placeholder="From Date"></kendo-datepicker>
            </div>
        </div>
        <div class="d-flex mr-3">
            <div class="f-col">
                <label class="mobile_lbl">To Date</label>
                <kendo-datepicker class="w-100 date_pik_mbl" v-model="ToTime" :name="'Date of start'" :format="'dd/MM/yyyy'"
                    placeholder="To Date"></kendo-datepicker>
            </div>
        </div>
        <div class="d-flex mr-3">
            <div class="f-col">
                <label class="mobile_lbl">Select RTO Number</label>
                <!-- <dropdownlist style="width: 190px" :data-items="getVehicles" :text-field="'rtoNumber'"
                    :data-item-key="'id'" v-model="searchingVehicleRtoNumber">
                </dropdownlist> -->
                <dropdownlist :data-items="getFilteredVehicles"  style="width: 190px" :data-item-key="'id'"
                    :filterable="true" :text-field="'rtoNumber'" v-model="RTOnumber" :name="'imeiVal'"
                    :required="true" @filterchange="filterChange" :default-item="defaultTeam" @change="changeVehicle">

                </dropdownlist>
            </div>
        </div>
     <div class="d-flex mr-3">
        <div title="Summary Report" v-if="isSummeryReportExist" class="rf-col mt-1 ml-2 mt-4" style="width: 79px;">
            <div class="d-flex">
              <label class="mt-2 mr-1">Summary</label> 
                <div class="checkbox ml-0 mr-2 mt-2">
                <input type="checkbox" v-model="showAllRec" class="{'active-track':track=='all'}" @change="$emit('onChangeSummaryRec',$event)"/>
                </div>
            </div>
            </div>
         </div>
        <div class="d-flex mr-3">
            <div class="f-col">
                <div class="p-2"></div>
                <kendo-button title="Search" :style="{ marginTop: '6px' }" class="k-primary ml-1"
                    @click="onChange">Search</kendo-button>
            </div>
        </div>
    </div>
</template>

<script>
import { formatISO } from '@/utils/date-helpers'
import { createNamespacedHelpers } from "vuex";
const {mapGetters } = createNamespacedHelpers("reports");
import { notifyWarn } from '@/utils/notification-helper';
export default {
  data() {
    return {
      RosterType: "General",
      FromTime:new Date(new Date().setHours(0,0,0,0)),
      ToTime:new Date(new Date().setHours(23,59,0,0)),
      RTONumber:this.allVehicle,
      RTOnumber:null,
      rtoValue:null,
      defaultTeam:{rtoNumber:"All",id:""},
      Speed:'',
      vehicleSearchFilter:''
    };
  },
  props:["field","isSummeryReportExist","isAdvanced"],
  methods: {
    onChange() {
      let t = this
      if(!(t.FromTime&&t.ToTime)){
        notifyWarn("Please select all the filters");
        return
      }
      this.$emit("update", {
        FromDate: formatISO(this.FromTime),
        ToDate: formatISO(this.ToTime),
        RTONumber:this.rtoValue ?this.rtoValue:'',
        TenantId:this.getTenantId,
        _query: {
          FromDate: formatISO(this.FromTime),
        ToDate: formatISO(this.ToTime),
        RTONumber:this.rtoValue ?this.rtoValue:'',
        TenantId:this.getTenantId,
        
        },
      });
    },
     filterChange(e) {
      this.vehicleSearchFilter = e.filter.value ? e.filter.value.toLowerCase() : "";
    },
    changeVehicle(e){
      if(this.isAdvanced)
     { if(e.value.rtoNumber =='All'){
       this.rtoValue =this.allVehicle
      }
      else
        this.rtoValue = [e.value.rtoNumber]
     
    }
    else {
      { if(e.value.rtoNumber =='All'){
       this.rtoValue =""
      }
      else
        this.rtoValue = e.value.rtoNumber
     
    }
    }
    }
  },
    computed: {
   ...mapGetters([ "getVehicles","getTenantId"]),
    getFilteredVehicles() {
      return this.getVehicles.filter((v) => v.rtoNumber.toLowerCase().includes(this.vehicleSearchFilter))
    },
    allVehicle(){
      
    return this.getVehicles.map(v=>{
       return v.rtoNumber
    })  
    }
    },
    created(){
     if(this.isAdvanced){
       this.rtoValue =this.allVehicle
     }
     else
     this.rtoValue=""
    }
};
</script>

<style>
</style>